<style scoped>

</style>

<template>
  <mu-button v-if="!simple" :small="small" icon :color="color" @click.stop.prevent="onClick" v-tooltip="text" :disabled="disabled">
    <mu-icon :value="icon"></mu-icon>
  </mu-button>
  <mu-list-item v-else button @click.stop.prevent="onClick" :disabled="disabled">
    <mu-list-item-action>
        <mu-icon :value="icon"></mu-icon>
    </mu-list-item-action>
    <mu-list-item-title>{{text}}</mu-list-item-title>
  </mu-list-item>
</template>

<script>
export default {
  name: 'ButtonOrListItem',
  props: {
    icon: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    small: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "default"
    },
    simple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      
    }
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
}

</script>
